import { useState } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import {
  ConceptListPanel,
  type ConceptPanelHeader,
} from "@tubo/semantic-concepts";
import {
  useSecondaryNavActions,
  useSecondaryNavTitle,
} from "@client/components/secondary-nav";

export const Route = createFileRoute("/_app/semantic-platform/concepts/")({
  // 领域上下文入 URL(刷新/分享链接可恢复;缺省=全局;条件赋值保证 ns 可选)
  validateSearch: (search: Record<string, unknown>): { ns?: string } => {
    return typeof search.ns === "string" && search.ns ? { ns: search.ns } : {};
  },
  component: ConceptListRoute,
});

/** 路由薄壳：面板头部注入次级导航栏，跳详情走路由 */
function ConceptListRoute() {
  const navigate = useNavigate();
  const { ns } = Route.useSearch();
  const [header, setHeader] = useState<ConceptPanelHeader | null>(null);

  useSecondaryNavTitle(header?.title);
  useSecondaryNavActions(header?.actions);

  return (
    <ConceptListPanel
      namespaceId={ns}
      onOpenConcept={(id) =>
        navigate({ to: "/semantic-platform/concepts/$id", params: { id }, search: ns ? { ns } : {} })
      }
      onHeaderChange={setHeader}
    />
  );
}
